// extracted by mini-css-extract-plugin
export var category = "_ij-9";
export var categoryHeader = "_ij-e";
export var container = "_ij-0";
export var group = "_ij-a";
export var groupItems = "_ij-f";
export var groupSeparator = "_ij-j";
export var loading = "_ij-1";
export var noResults = "_ij-3";
export var placeholder = "_ij-2";
export var resultContent = "_ij-5";
export var resultIcon = "_ij-c";
export var resultItem = "_ij-g";
export var resultMeta = "_ij-8";
export var resultSubtitle = "_ij-7";
export var resultSuffix = "_ij-i";
export var resultTitle = "_ij-6";
export var resultsList = "_ij-4";
export var searchGroup = "_ij-d";
export var selected = "_ij-h";
export var subgroup = "_ij-b";